<template>
  <el-form
    class="changeMail form-container"
    ref="form"
    :model="form"
    label-width="0px"
    :rules="rules"
  >
    <el-form-item  prop="email">
      <el-input type="email" placeholder="请输入邮箱" v-model="form.email">
      </el-input>
    </el-form-item>
    <el-form-item prop="VerificationCode">
      <el-input placeholder="请输入验证码" v-model="form.VerificationCode">
          <el-button slot='append' @click="requestSmsCode" :disabled="smsLimit?'disabled':false">
            {{smsLimit>0?`${smsLimit}s`:"验证码"}}</el-button>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit" size="small">绑定</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import { getSmsCode, modifyPersonalInfo } from '@/api/personal-center/setting';

export default {
  name: 'changeMail',
  data() {
    const validateMail = (rule, value, callback) => {
      if (/^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/.test(value)) {
        callback();
        return;
      }
      callback(new Error('请输入正确的电子邮箱'));
    };
    return {
      smsLimit: 0,
      form: {
      },
      rules: {
        email: [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur',
        }, {
          validator: validateMail,
          trigger: 'blur',
        }],
        VerificationCode: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur',
        }, {
          min: 4,
          max: 8,
          message: '长度在4~8个字符',
          trigger: 'blur',
        }],
      },
    };
  },
  computed: {
    accountId() {
      return this.$store.getters.accountId;
    },
  },
  methods: {
    onSubmit() {
      const formData = new FormData();
      formData.append('Email', this.form.email);
      formData.append('VerifyCode', this.form.VerificationCode);
      modifyPersonalInfo(formData, {
        UIDstr: this.accountId,
      }).then(() => {
        this.$message({
          message: '设置成功',
          type: 'success',
        });
        setTimeout(() => {
          this.$emit('changeResult', 1);
        }, 5000);
      }).catch(() => {
        this.$message({
          message: '设置失败，请重试！',
          type: 'warning',
        });
      });
    },
    requestSmsCode() {
      console.log('邮箱设置');
      if (!/^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/.test(this.form.email)) {
        this.$message({
          message: '请输入正确的电子邮箱',
          type: 'warning',
        });
        return;
      }
      getSmsCode({
        PhoneNumber: this.form.email,
      }).then((res) => {
        console.log('res', res);
        this.resetCountDown();
      });
    },
    resetCountDown() {
      this.smsLimit = 90;
      setTimeout(this.countDown, 1000);
    },
    countDown() {
      if (!this.smsLimit) {
        return;
      }
      this.smsLimit -= 1;
      setTimeout(this.countDown, 1000);
    },
  },
};
</script>
<style scoped>
.form-container {
  padding: 2% 5%;
}
</style>
